import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../../constants/styles';

const {
  FLAT_BUTTON_BG_COLOR,
  FLAT_BUTTON_COLOR,
  WORKFLOWS_BORDER_COLOR
} = constants;

let styles = {
  label: {
    fontWeight: 500
  },
  flatButton: {
    backgroundColor: FLAT_BUTTON_BG_COLOR,
    color: FLAT_BUTTON_COLOR,
    ':hover': {
      backgroundColor: 'none'
    }
  },
  addButton: {
    textTransform: 'capitalize',
    fontSize: '0.8em',
    color: FLAT_BUTTON_COLOR,
    border: `1px solid ${FLAT_BUTTON_COLOR}`,
    borderRadius: 5,
    backgroundColor: 'white',
    minWidth: 30,
    padding: '5px 8px',
    marginTop: 10,
    ':hover': {
      backgroundColor: WORKFLOWS_BORDER_COLOR
    }
  },
  criteriaButton: {
    fontSize: '0.9em'
  },
  criteriaField: {
    marginTop: 10
  },
  criteriaProperty: {
    textTransform: 'lowercase',
    marginBottom: 10
  },
  criteriaTitle: {
    paddingBottom: 10
  },
  criteriaList: {
    width: '100%'
  },
  criteria: {
    width: '100%'
  },
  criteriaType: {
    boxSizing: 'border-box',
    fontSize: '0.95em',
    border: `1px solid ${WORKFLOWS_BORDER_COLOR}`,
    borderRadius: 5,
    padding: '10px 15px'
  },
  separator: {
    height: 50,
    borderLeft: `1px solid ${WORKFLOWS_BORDER_COLOR}`
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addtriggerform/addcriteriaform/AddCriteriaForm.styles.js